/*
 * @Author: your name
 * @Date: 2019-12-16 22:07:57
 * @LastEditTime: 2020-04-02 21:19:49
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \周记 张经伟e:\gi劳务\src\router\modules\craftsmanInformation.js
 */
const CraftsmanInformation = () => import('@/views/craftsmanInformation/index')//工匠资讯
const CraftsmanInformationDetail = () => import('@/views/craftsmanInformation/CraftsmanInformationDetail')//工匠资讯详情
const craftsmanInformationRouter = [
    {
        path: '/craftsmanInformation',
        name: 'craftsmanInformation',
        component: CraftsmanInformation,
        meta: {
            name: '工匠专访', //工匠资讯改为了“工匠专访”
            keepAlive: true,
        }
    },
    {
        path: '/craftsmanInformation/detail/:id',
        name: 'craftsmanInformationDetail',
        component: CraftsmanInformationDetail,
        meta: {
            name: '工匠专访详情' //工匠资讯详情改为”工匠专访详情“
        }
    }
]
export default craftsmanInformationRouter;


// WEBPACK FOOTER //
// ./src/router/modules/craftsmanInformation.js